import { render, staticRenderFns } from "./FifteenTable.vue?vue&type=template&id=18e4edf0&"
import script from "./FifteenTable.vue?vue&type=script&lang=js&"
export * from "./FifteenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports